<template>
  <div id="app" v-if="true">
    <router-view />
  </div>
</template>

<script>
import * as http from "@/util/getToken.js";
export default {
  data() {
    return {
      toekenData: false,
    };
  },
  beforeCreate() {
    // if (/Mobi/.test(navigator.userAgent)) {
    //   // console.log('是移动设备');
    //   function setRootFontSize() {
    //     var width = 750;
    //     var fontSize = width / 10;
    //     document.getElementsByTagName('html')[0].style.fontSize = "calc(100vw / 7.5)"
    //   }
    //   setRootFontSize();

    //   window.addEventListener('resize', function () {
    //     setRootFontSize();
    //   });

    //   // 移动设备
    // } else {
    //   // 台式机或电脑
    // }
    // http
    //   .geToken({
    //     appId: "oNKS8sO0",
    //     appSecret: "b573f0c44d9a7a999b7c2f14232898525a1c395d",
    //   })
    //   .then((res) => {
    //     console.log("res", res);
    //     sessionStorage.setItem("userToken", JSON.stringify(res.data.data));
    //     this.toekenData = true;
    //   });
  },
  async created() {
    // http
    //   .geTokenGuoDian({
    //     username: "admin",
    //     password: "admin123456",
    //   })
    //   .then((resdata) => {
    //     sessionStorage.setItem("user", JSON.stringify(resdata));
    //   });
    // let res = http.$getToken({
    //   //获取token存入本地
    //   username: "admin",
    //   password: "admin123456",
    // });
    // let resTax = http.$getTokenTax({
    //   //获取token存入本地
    //   username: "admin",
    //   password: "admin123456",
    // });
    // if (res) {
    //   this.toekenData = res;
    //   console.log("token", res);
    //   sessionStorage.setItem("user", JSON.stringify(res));
    // }
    // if (resTax) {
    //   sessionStorage.setItem("userTax", JSON.stringify(resTax));
    // }
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  user-select: none;
}

#app {
  // height: 100%;
  // width: 3820px;
  // width: 100%;
  // background: rgba($color: #000000, $alpha: 1.0);
  user-select: none;
  position: relative;
}
</style>
